import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

interface CookieConsentProps {
  onAccept: () => void;
  onDecline: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept, onDecline }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const hasConsent = localStorage.getItem('cookie-consent');
    
    if (!hasConsent) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
    onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
    onDecline();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between">
          <div className="flex-1 pr-4 mb-4 md:mb-0">
            <h3 className="text-lg font-medium text-gray-900 mb-1">Chúng tôi sử dụng cookie</h3>
            <p className="text-sm text-gray-600">
              Website này sử dụng cookie để cải thiện trải nghiệm người dùng và phân tích lưu lượng truy cập. 
              Bằng cách nhấp vào "Đồng ý", bạn chấp nhận việc sử dụng cookie của chúng tôi.
            </p>
          </div>
          <div className="flex flex-shrink-0 space-x-3">
            <button
              onClick={handleDecline}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Từ chối
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 bg-blue-600 border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700"
            >
              Đồng ý
            </button>
          </div>
          <button
            onClick={handleDecline}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-500"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;